import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface MarqueeProps {
  children: ReactNode;
  speed?: 'slow' | 'medium' | 'fast';
  pauseOnHover?: boolean;
  className?: string;
}

export function Marquee({
  children,
  speed = 'medium',
  pauseOnHover = true,
  className,
}: MarqueeProps) {
  const animation =
    speed === 'slow' ? 'animate-marquee-slow' : 'animate-marquee';
  return (
    <div className={cn('group flex w-full overflow-hidden mask-fade-edges', className)}>
      <div
        className={cn(
          'flex shrink-0 items-center gap-12 pr-12',
          animation,
          pauseOnHover && 'group-hover:[animation-play-state:paused]',
        )}
      >
        {children}
      </div>
      <div
        aria-hidden
        className={cn(
          'flex shrink-0 items-center gap-12 pr-12',
          animation,
          pauseOnHover && 'group-hover:[animation-play-state:paused]',
        )}
      >
        {children}
      </div>
    </div>
  );
}
